<template>

<div class="main" id="detail-4473-clean" style="top: -3em;">

	<div class="customer-page-header">
		<div>
			<img v-if="getClient.logo_src" :src="getClient.logo_src">
			<div v-else>{{ getClient.company_name }}</div>
		</div>
		<div>
			<h1 style="margin: 0;">Firearms Transaction Record, Form 4473</h1>
			<div style="text-align: right; font-size: 0.9em; padding: 0.25em 0 0 0;">{{ $fullName(contactData) }}</div>
		</div>
	</div>

	<div v-if="form.form_data" class="detail form-detail" ref="section_top" style="display: grid; grid-template-columns: 1fr auto;">
		<div class="customer-form-detail" id="customer-form-detail">
			<div class="section-a-summary form-detail">
				<div class="section-subhead"> Firearms Included in this Form </div>
				<div class="five-columns section_a_firearm column-header">
					<div>Manufacturer</div>
					<div>Type</div>
					<div>Model</div>
					<div>Caliber</div>
					<div>Serial Number</div>
				</div>
				<div v-for="(firearm, index) in form.form_data.section_a.firearms_list" class="five-columns section_a_firearm">
					<div class="firearm-line-number">{{ index + 1 }}</div>
					<div>{{ firearm.manufacturer }}</div>
					<div>{{ firearm.gun_type }}</div>
					<div>{{ firearm.model }}</div>
					<div>{{ firearm.caliber }}</div>
					<div>{{ firearm.serial_number }}</div>
				</div>
			</div>
			<div style="float: right; margin: 0 2em 0 0; position: relative; z-index: 2;">
				<binary-toggle v-model="spanishLanguage" values=",1" labels="English,Spanish" style="margin-bottom: 0.15em;" />
			</div>
			<section-b-2022 v-if="form.version == '3'" :form="form" :spanishLanguage="spanishLanguage" ref="sectionB" :locked="formSection == 'section_d'" :enableSignOnScreen="enableSignOnScreen" :correcting="correctingSection" />
			<section-b-2023 v-if="form.version == '4'" :form="form" :spanishLanguage="spanishLanguage" ref="sectionB" :locked="formSection == 'section_d'" :enableSignOnScreen="enableSignOnScreen" :correcting="correctingSection" />
			<section-d v-show="formSection == 'section_d'" :form="form" :spanishLanguage="spanishLanguage" ref="sectionD" :enableSignOnScreen="enableSignOnScreen" :correcting="correctingSection" />

			<div v-if="form.internal_use_only" style="margin: 1em 0 0 0;">
				<h1 style="border-bottom: 1px solid #ccc; padding: 0 0 0.25em 0;">Transferee / Buyer Initials</h1>
				<div class="two-columns" style="align-items: center; width: 42em; padding: 0 0 0 10em; margin: 0 auto;">
					<label>Enter your initials to confirm that you personally made these corrections</label>
					<input type="text" v-model="userInitials" style="width: 6em; border: 1px solid #000;" placeholder="Initials">
				</div>
			</div>
			<div class="controls" style="margin: 1em 0 3em 0;">
				<div class="button cancel spaced" @click="confirmCancel = true">Cancel</div>
				<div v-if="form.internal_use_only" :class="['button', userInitials.length > 1 ? 'action' : 'disabled', 'spaced']" @click="moveAndSaveSection()">Save Corrections</div>
				<div v-else class="button action spaced" @click="saveSection()">Save Transferee / Buyer Info</div>
			</div>

			<div class="mobile-spacer"></div>

		</div>
		<instructions-2022 v-if="form.version == '3'" :section="formSection" :spanishLanguage="spanishLanguage" style="margin: 1em 0 0 0;" />
		<instructions-2023 v-if="form.version == '4'" :section="formSection" :spanishLanguage="spanishLanguage" style="margin: 1em 0 0 0;" />
	</div>

	<div v-if="confirmCancel" class="modal">
		<div class="inner">
			<h2>Confirm Cancel</h2>
			<div class="content">
				<p>Are you sure you want to cancel?<br>Anything you've entered will not be saved.</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="confirmCancel = false">No</div>
				<div class="button cancel spaced" @click="cancelAndLogout()">Yes, cancel</div>
			</div>
		</div>
	</div>

	<div v-if="confirmAlert" class="modal">
		<div class="inner">
			<h2>Alert</h2>
			<div class="content">
				<p>{{ form.alert }}</p>
				<p>Are you sure you want to proceed with {{ formSection.capitalizeWords() }}?</p>
			</div>
			<div class="controls">
				<div class="button neutral spaced" @click="confirmAlert = false">Yes</div>
				<div class="button neutral spaced" @click="cancelAndLogout()">No</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" @action="doMessageModalAction()" />

</div>

</template>

<script>
import styles from '../detail_4473_clean.scss'
import BinaryToggle from '@/components/BinaryToggle.vue'

// using arrow functions to lazy load components
// https://vuedose.tips/dynamic-imports-in-vue-js-for-better-performance
const SectionB2023 = () => import('../components/4473SectionB2023.vue')
const SectionB2022 = () => import('../components/4473SectionB2022.vue')
const SectionD = () => import('../components/4473SectionD.vue')
const Instructions2023 = () => import('../components/Instructions2023.vue')
const Instructions2022 = () => import('../components/Instructions2022.vue')

export default {
	name: 'customer-form-4473-clean',
	props: ['ffl_log_book_form_id'],
    components: {
        'binary-toggle': BinaryToggle,
        'section-b-2022': SectionB2022,
        'section-b-2023': SectionB2023,
        'section-d': SectionD,
		'instructions-2022': Instructions2022,
		'instructions-2023': Instructions2023
    },
	data() {
		return {
			printing: false,
    		loading: false,
			clientHasVariance: false,
			spanishLanguage: '',
			formSection: 'section_b',
			correctingSection: false,
			userInitials: '',
            contactData: {},
            form: {},
			confirmCancel: false,
			message: '',
			saving: false,
			messageStatus: '',
			messageTimeout: 0,
			enableSignOnScreen: '',
			confirmAlert: false
		}
	},
	created() {
		if (!sessionStorage.getItem('auth')) {
			this.$router.push('/logbooks/customer-4473')
		}
		if (this.$route.query.section && this.$route.query.section == 'D') {
			this.formSection = 'section_d'
		}
		if (this.$route.query.correcting) {
			this.correctingSection = this.$route.query.section
		}
        this.loading = true
        this.apiCall({ destination: 'get_item_ffl_log_book_form', data: { kiosk_mode: true, ffl_log_book_form_id: this.ffl_log_book_form_id } }).then(obj => {
            this.loading = false
            if (obj.status == 'success') {
                this.contactData = obj.contact_data
                this.form = obj.log_book_form
                this.enableSignOnScreen = obj.enable_screen_capture_signature
				this.clientHasVariance = obj.electronic_storage_variance
				if (!this.clientHasVariance) {
					this.correctingSection = false
				}
				if (this.form.alert) {
					this.confirmAlert = true
				}
				sessionStorage.removeItem('auth')
			} else {
                this.message = obj.message
            }
        })
	},
	beforeRouteLeave (to, from , next) {
		sessionStorage.removeItem('auth')
		next()
	},
	methods: {
		saveSection() {
			if (this.saving) { return }
            this.saving = true
			let errorMessage = ''
			if (this.formSection == 'section_b') {
				errorMessage = this.$refs.sectionB.validateSection()
			}
			if (this.formSection == 'section_d') {
				errorMessage = this.$refs.sectionD.validateSection()
			}
			if (errorMessage) {
				this.message = errorMessage
				this.saving = false
				this.messageStatus = 'invalid'
				return false
			}
			// start with the full contact object return from get_item_ffl_log_book_form so we don't overwrite email address and other "extra" fields
			let contactData = this.contactData
			contactData.first_name = this.form.form_data.section_b.first_name
			contactData.middle_name = this.form.form_data.section_b.middle_name
			contactData.last_name = this.form.form_data.section_b.last_name
			contactData.suffix = this.form.form_data.section_b.suffix
			contactData.address_1 = this.form.form_data.section_b.address_1
			contactData.city = this.form.form_data.section_b.city
			contactData.state = this.form.form_data.section_b.state
			contactData.zip_code = this.form.form_data.section_b.zip_code
			contactData.birthdate = this.form.form_data.section_b.birthdate
			let data = {
				kiosk_mode: true,
                ffl_log_book_form_id: this.ffl_log_book_form_id,
				contact_data: contactData,
                form: this.form,
                form_section: this.formSection,
				version: 3
            }
			this.message = 'Saving 4473 Section ' + this.formSection.replace('section_', '').toUpperCase()
			this.apiCall({ destination: 'save_4473_section', data: data }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
                if (obj.status == 'success') {
					this.message = '4473 Section ' + this.formSection.replace('section_', '').toUpperCase() + ' saved!'
					this.messageTimeout = 2000
					setTimeout(() => { this.cancelAndLogout() }, 2000)
                } else {
                    this.message = obj.message
                }
            })
		},
		moveAndSaveSection() {
			if (this.saving || !this.userInitials) { return }
            this.saving = true
			let errorMessage = ''
			if (this.formSection == 'section_b') {
				errorMessage = this.$refs.sectionB.validateSection()
			}
			if (this.formSection == 'section_d') {
				errorMessage = this.$refs.sectionD.validateSection()
			}
			if (errorMessage) {
				this.message = errorMessage
				this.saving = false
				this.messageStatus = 'invalid'
				return false
			}
			this.message = 'Saving 4473 Section ' + this.formSection.replace('section_', '').toUpperCase()
			this.saving = true
			// start with the full contact object return from get_item_ffl_log_book_form so we don't overwrite email address and other "extra" fields
			let contactData = this.contactData
			contactData.first_name = this.form.form_data.section_b.first_name
			contactData.middle_name = this.form.form_data.section_b.middle_name
			contactData.last_name = this.form.form_data.section_b.last_name
			contactData.address_1 = this.form.form_data.section_b.address_1
			contactData.city = this.form.form_data.section_b.city
			contactData.state = this.form.form_data.section_b.state
			contactData.zip_code = this.form.form_data.section_b.zip_code
			contactData.birthdate = this.form.form_data.section_b.birthdate
			let data = {
				old_ffl_log_book_form_id: this.ffl_log_book_form_id,
				contact_id: this.form.contact_id,
                user_initials: this.userInitials,
				form_section: this.formSection,
				form: {
					form_data: this.form.form_data,
				},
				contact: contactData
			}
			// send to server
			this.apiCall({ destination: 'move_item_4473', data: data }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.message = '4473 Section ' + this.formSection.replace('section_', '').toUpperCase() + ' saved!'
					this.messageTimeout = 2000
					setTimeout(() => { this.cancelAndLogout() }, 2000)
				} else {
					this.message = obj.message
				}
			})
		},
		cancelAndLogout() {
			this.$router.push('/logbooks/customer-4473')
		}
    }
}
</script>


<style lang="scss" scoped>
#customer-form-detail {
	max-width: 66em;
	margin: 0 auto;
}
.column-header {
	background-color: #ededed;
	margin-top: 1em !important;
}
.section_a_firearm {
	position: relative;
	padding: 1em;
	margin: 0 2em;
	.firearm-line-number {
		position: absolute;
		font-size: 0.8em;
		left: -1.8em;
		top: 1.25em;
		border: 1px solid #999;
		border-radius: 1em;
		padding: 0.1em 0.33em 0 0.33em;
	}
}


</style>
